import { Component, OnInit, Inject, AfterViewInit, ViewChild, HostListener, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd, NavigationExtras } from "@angular/router";
import{ToastrService}from 'ngx-toastr';
import{DataService} from '../../services/data.service';
import{AuthService} from '../../services/auth.service';
import{Location} from '@angular/common'
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MdbTablePaginationComponent, MdbTableDirective } from 'angular-bootstrap-md'
import { state } from '@angular/animations';
@Component({
  selector: 'app-list-entity',
  templateUrl: './list-entity.component.html',
  styleUrls: ['./list-entity.component.scss']
})
export class ListEntityComponent implements OnInit {
  page: number=0;
  pageSize: number=25;
  entityResolutionStatus:string="IN_QACHECK";
  src: any;
  total: any;
  entityType:string="Individual"
  source: any;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = false;
  public maxSize: number = 9;
  searchText:string;
  constructor(
    public router:Router,
    public activatedRoute:ActivatedRoute,
    private data:DataService,
    private toaster:ToastrService,
    private auth:AuthService,
    private location:Location,
    private spinner:NgxSpinnerService,
    private modalService:NgbModal,
    private fb:FormBuilder,
    @Inject("API_URL") public API_URL: any,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
     this.source=this.activatedRoute.snapshot.paramMap.get('id')
     console.log(this.source)
     this.getAllEntity(this.page,this.pageSize,this.source,this.entityResolutionStatus,this.entityType)
  }
searchEntity(){

}
getAllEntity(page=this.page,size=this.pageSize,name=this.source,erStatus=this.entityResolutionStatus,type=this.entityType){
    let abc={
      "page" :  page,
        "size" : size,
        "order" : "ASC",
        "orderBy":"details",
        "source":[name],
        "entityResolutionStatus":erStatus,
        "type":[type]
        
  
    }
    this.spinner.show()
    this.data.searchErSource(abc).subscribe(
      data=>{
        
        if(data.statusCode==200){
          this.spinner.hide()
          console.log(data)
          this.src=data['data']['content']
          console.log("hii",this.src)
          this.total=data['data'].totalElements
          this.page=data['data']['pageable'].pageNumber
        }
      },
      (err:HttpErrorResponse)=>{
        console.log(err)
        this.spinner.hide
          let alertObj = {
            message:err.error.message,
            status: err.error.infoType,
            autoDismiss: true,
            timeToDismiss: 5000
          };
          this.data.toastrShow(alertObj.message,alertObj.status)
      }
    )
  }
  pagec(event){
    console.log(event)
    this.page=event-1
    this.getAllEntity(this.page,this.pageSize,this.source,this.entityResolutionStatus,this.entityType)
  }
  increaseSize(event){
  console.log(event)
  this.getAllEntity(this.page,event,this.source,this.entityResolutionStatus,this.entityType)
  }
  filterStatus(event){
    this.getAllEntity(this.page,this.pageSize,this.source,event,this.entityType)
  }
  filterType(event){
    this.getAllEntity(this.page,this.pageSize,this.source,this.entityResolutionStatus,event)

  }
  onClickSearch($event,item:Object){
    console.log(item)
    this.router.navigate(['/group-entities'],{state:{data:{item}}})
  }
  logout(){
    this.auth.logout();
  }
  goback(){
    this.location.back();
  }
}
